// src/config.ts

// Environment-specific configuration
export const API_BASE_URL = (() => {
  // Get environment variable or default
  const configuredUrl = (import.meta as any).env.VITE_API_BASE_URL;
  
  // If explicitly configured, use that
  if (configuredUrl) return configuredUrl;
  
  // For development on desktop
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5001';
  }
  
  // For production or other environments, use relative URL which avoids CORS
  // This helps with Safari on iOS which can have issues with cross-origin requests
  return `${window.location.protocol}//${window.location.hostname}${window.location.hostname === 'lsnto.com' ? '/api' : ':5001'}`;
})();

// Application configuration
export const APP_CONFIG = {
  appName: "Lsnto",
  appVersion: "1.0.0",
  appDescription: "A music streaming platform",
};

// Authentication configuration
export const AUTH_CONFIG = {
  tokenStorageKey: "access_token",
  refreshTokenStorageKey: "refresh_token",
  tokenExpiryKey: "token_expiry",
  loginRedirectPath: "/discover",
  logoutRedirectPath: "/login",
  adminRedirectPath: "/admin/dashboard",
  artistRedirectPath: "/artist/dashboard",
};

// Subscription configuration
export const SUBSCRIPTION_CONFIG = {
  standardPriceId:
    ((import.meta as any).env?.VITE_STRIPE_STANDARD_PRICE_ID as string | undefined) ??
    "price_1RYoBKER541rKiq9p4KrMTK5",
  successFlowParam: "subscription",
  publishableKey: (import.meta as any).env?.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined,
};

// Media configuration
export const MEDIA_CONFIG = {
  maxImageSizeMB: 5,
  maxAudioSizeMB: 50,
  allowedImageTypes: ["image/jpeg", "image/png", "image/gif", "image/webp"],
  allowedAudioTypes: [
    "audio/mpeg",
    "audio/mp3",
    "audio/wav",
    "audio/x-wav",
    "audio/aac",
    "audio/m4a",
    "audio/mp4",
    "audio/x-m4a",
    "application/octet-stream"
  ],
  defaultImageExpiry: 60, // seconds
  defaultAudioExpiry: 60, // seconds
}; 
